import PropTypes from 'prop-types';
import React from 'react';

const BURGER = {
  viewBox: "0 0 64 54",
  paths: (
    <g>
      <path d="M58.9 21.333H5.1c-2.817 0-5.1 2.384-5.1 5.334C0 29.617 2.283 32 5.1 32h53.8c2.817 0 5.1-2.383 5.1-5.333s-2.283-5.334-5.1-5.334"/>
      <path d="M58.9 0H5.1C2.283 0 0 2.383 0 5.333s2.283 5.334 5.1 5.334h53.8c2.817 0 5.1-2.384 5.1-5.334C64 2.383 61.717 0 58.9 0"/>
      <path d="M58.9 42.667H5.1C2.283 42.667 0 45.05 0 48s2.283 5.333 5.1 5.333h53.8c2.817 0 5.1-2.383 5.1-5.333s-2.283-5.333-5.1-5.333"/>
    </g>
  )
};

const CROSS = {
  viewBox: "0 0 64 64",
  paths: (
    <path d="M63.275 53.79L41.408 31.85l21.917-21.655c.9-.9.9-2.366 0-3.265L57.092.666C56.658.233 56.075 0 55.46 0c-.618 0-1.202.25-1.635.666l-21.817 21.59L10.158.682C9.725.25 9.142.016 8.525.016s-1.2.25-1.633.667L.675 6.946c-.9.9-.9 2.366 0 3.265l21.917 21.66L.742 53.79c-.434.432-.684 1.015-.684 1.63 0 .617.234 1.2.684 1.634l6.233 6.263c.45.45 1.033.683 1.633.683.584 0 1.184-.217 1.634-.683l21.766-21.855L53.792 63.3c.45.45 1.033.683 1.633.683.583 0 1.183-.216 1.633-.683l6.234-6.263c.433-.433.683-1.016.683-1.633-.017-.6-.267-1.182-.7-1.615"  fillRule="evenodd"/>
  )
};

function BurgerIcon({title, close = false}) {
  const {viewBox, paths} = close ? CROSS : BURGER;

  return (
    <svg className="burger-icon" viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <title>{title}</title>
      {paths}
    </svg>
  );
}

BurgerIcon.propTypes = {
  title: PropTypes.string.isRequired,
  close: PropTypes.bool
}

export default BurgerIcon



// WEBPACK FOOTER //
// ./modules/Common/components/svg/BurgerIcon.js